"use strict";
var decorators_1 = require("./pipes/decorators");
exports.Pipe = decorators_1.Pipe;
//# sourceMappingURL=pipes.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/ng-metadata/src/core/pipes.js
 ** module id = 145
 ** module chunks = 0 1
 **/